<template lang="html">
  <b-container>
    <h3>Profile and Settings</h3>
    <div class="row justify-content-between">
      <div class="col-md-3 mb-3 my-1">
        <ProfilePhoto></ProfilePhoto>
      </div>
      <div class="col-md-9 mb-3 my-1">
        <ProfileEdit></ProfileEdit>
      </div>
    </div>
  </b-container>
</template>

<script>
import ProfilePhoto from "./ProfilePhoto.vue";
import ProfileEdit from "./ProfileEdit.vue";

export default {
  components: {
    ProfilePhoto,
    ProfileEdit
  },
  computed: {},
  actions: {},
}
</script>

<style lang="scss" scoped>
</style>
